import { BindingCreator } from '@dreryk/react-common';

import { ReferralToHospitalFormBean, ReferralToHospitalFormController } from '../ReferralToHospitalForm.types';
import { HealthcareFacilityLocationSpecialtyField as BaseHealthcareFacilitySpecialtyField } from '../../../shared/HealthcareFacilitySpecialtyField/HealthcareFacilityLocationSpecialtyField';

import { isHealthcareFacilityLocationSpecialtyPsychiatric } from './HealthcareFacilitySpecialtyField.utils';
import { HealthcareFacilitySpecialtyFieldValidationErrorNotification } from './HealthcareFacilitySpecialtyFieldValidationErrorNotification';

type HealthcareFacilitySpecialtyFieldProps = {
   readonly register: BindingCreator<ReferralToHospitalFormBean>;
   readonly watch: ReferralToHospitalFormController['watch'];
   readonly errors: { healthcareFacilityLocationSpecialty?: unknown };
   readonly visitId: number;
};

export const HealthcareFacilitySpecialtyField = (props: HealthcareFacilitySpecialtyFieldProps): JSX.Element => {
   const currentHealthcareFacilityLocationSpecialty = props.watch('healthcareFacilityLocationSpecialty');

   return (
      <BaseHealthcareFacilitySpecialtyField specialtyType={'hospitalWard'} register={props.register}>
         <>
            {currentHealthcareFacilityLocationSpecialty &&
            props.errors.healthcareFacilityLocationSpecialty &&
            isHealthcareFacilityLocationSpecialtyPsychiatric(currentHealthcareFacilityLocationSpecialty) ? (
               <HealthcareFacilitySpecialtyFieldValidationErrorNotification visitId={props.visitId} />
            ) : null}
         </>
      </BaseHealthcareFacilitySpecialtyField>
   );
};
